import { CurrencyPipe, DecimalPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { BlinkDirective } from '@zero/shared/ui-directives';
import { InstrumentDetailsLinkComponent } from '@zero/shared/ui-web-components';
import { IconComponent } from '@zero/shared/ui-web-design-system';
import { TopInstrument } from '@zero/shared/util-models';
import { commonRoutes } from 'constants/web-app-constants';

@Component({
  selector: 'home-my-top-instrument-item',
  templateUrl: './my-top-instrument-item.component.html',
  styleUrls: ['./my-top-instrument-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    InstrumentDetailsLinkComponent,
    BlinkDirective,
    NgClass,
    RouterLink,
    DecimalPipe,
    CurrencyPipe,
    TranslocoPipe,
    NgTemplateOutlet,
    IconComponent,
  ],
})
export class MyTopInstrumentItemComponent {
  @Input() public item: TopInstrument;
  @Input() public index: number;

  public readonly commonRoutes = commonRoutes;
}
